import ClassNames from "classnames";
import { FunctionComponent } from "react";
import { checkIsPlaceholder } from "../selectors/pictures.js";
import { getActiveSite } from "../selectors/sites.js";
import { useAppSelector } from "../store/hooks.js";
import styles from "../stylesheets/components/header-logo.module.css";
import {
  ColorScheme,
  HeaderLogoBackground,
  Picture,
  ThreeSizes,
} from "../types/index.js";
import { css } from "../utils/emotion.js";
import { fitRectWidth, logoSizeMultipliers } from "../utils/utils.js";
import SmartLink from "./SmartLink.js";

interface Props {
  isPreview: boolean;
  logo: Picture;
  logoBackground?: HeaderLogoBackground;
  mainPageURL: string | undefined;
  maxSize: { width: number; height: number };
  scheme: ColorScheme;
  size: ThreeSizes;
  className?: string;
  imageClassName?: string;
}

const HeaderLogo: FunctionComponent<Props> = ({
  size,
  maxSize,
  isPreview,
  logo,
  logoBackground,
  mainPageURL,
  scheme,
  className,
  imageClassName,
}) => {
  const accommodationName = useAppSelector(
    (state) => getActiveSite(state.sites)?.accommodation.name,
  );
  const width = Math.round(
    logoSizeMultipliers[size] *
      fitRectWidth({ width: logo.width, height: logo.height }, maxSize),
  );
  const height = Math.round(width * (logo.height / logo.width));
  const src = logo.url;

  return checkIsPlaceholder(logo) ? null : (
    <div
      className={ClassNames(
        styles.HeaderModule__Logo,
        className,
        logoBackground &&
          css({
            backgroundColor:
              logoBackground === "color-scheme-background"
                ? scheme.main.background
                : logoBackground,
          }),
      )}
    >
      <SmartLink
        anchorAttrs={{ href: mainPageURL || "#" }}
        isPreview={isPreview}
      >
        <img
          className={ClassNames(
            styles.HeaderModule__LogoImage,
            imageClassName,
            css({ width }),
          )}
          src={src}
          title={logo.title ?? undefined}
          alt={logo.title ?? accommodationName ?? ""}
          width={width}
          height={height}
        />
      </SmartLink>
    </div>
  );
};

export default HeaderLogo;
